import { toTitleCase } from '../../utils';
import { formatEpochToDateString } from '../../utils/commonUtils';

// const getReturnLabel = (returnsLabelArr) => {
//   const returnItem = returnsLabelArr.filter((returnObj) => returnObj.value);
//   if (returnItem.length) {
//     return returnItem[0];
//   }
//   return {
//     value: '--',
//     label: 'Returns per yr (5 Year Avg)',
//   };
// };

// const returnHighlights = (returnsLabelArr) => {
//   const { value } = getReturnLabel(returnsLabelArr);
//   // const navDate = new Date(dayEndDate).toDateString().slice(4);
//   return [
//     {
//       image:
//         'https://assets1.cleartax-cdn.com/cleartax/images/1628613984_shape.svg',
//       label: '3 yr CAGR',
//       value: `${value}%`,
//     },
//     // {
//     //   image: 'https://assets1.cleartax-cdn.com/clearsave/images/time_icon.svg',
//     //   label: `NAV as on ${navDate}`,
//     //   value: `${dayEndNav}`,
//     //   navChange,
//     // },
//   ];
// };

const fundDetailsBlock = (props: any) => {
  return (
    <div className="lil-flex lil-flex-wrap lil-items-center">
      {props.risk && (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300 sm:lil-text-s-14">
            {toTitleCase(props.risk)}Risk
          </p>
        </div>
      )}

      {props.category && (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300 sm:lil-text-s-14">
            {toTitleCase(props.category)}
          </p>
        </div>
      )}

      {!props.isNfo && props.morningStar && Number(props.morningStar) > 0 ? (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300 sm:lil-text-s-14">
            {props.morningStar} Star
          </p>
        </div>
      ) : (
        ''
      )}
      {/* {props.purchaseMode && (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300 sm:lil-text-s-14">
            {toTitleCase(props.purchaseMode)}
          </p>
        </div>
      )}

      {props.planType && (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300  sm:lil-text-s-14">
            {toTitleCase(props.planType)}
          </p>
        </div>
      )} */}

      {/* {props.isElss && props.ELSS ? (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300  sm:lil-text-s-14">
            {props.ELSS}
          </p>
        </div>
      ) : null} */}
    </div>
  );
};

// Map time period to display label
const getReturnsLabel = (timePeriod: string) => {
  const labelMap: { [key: string]: string } = {
    '1M': '1M returns',
    '3M': '3M returns',
    '6M': '6M returns',
    '1Y': '1Y returns',
    '3Y': '3Y returns',
    '5Y': '5Y returns',
    MAX: 'MAX returns',
  };
  return labelMap[timePeriod] || 'Returns since inception';
};

// Calculate absolute return from graph data for a specific time period
const calculateAbsoluteReturnForPeriod = (
  graphData: any[],
  timePeriod: string
) => {
  if (!graphData || graphData.length < 2) {
    return null;
  }

  // Get the last item (current NAV)
  const lastItem = graphData[graphData.length - 1];
  if (!lastItem) {
    return null;
  }

  const lastNav = lastItem.y;
  const lastDate = new Date(lastItem.x);

  // Calculate the start date based on time period
  const startDate = new Date(lastDate);
  switch (timePeriod) {
    case '1M':
      startDate.setMonth(startDate.getMonth() - 1);
      break;
    case '3M':
      startDate.setMonth(startDate.getMonth() - 3);
      break;
    case '6M':
      startDate.setMonth(startDate.getMonth() - 6);
      break;
    case '1Y':
      startDate.setFullYear(startDate.getFullYear() - 1);
      break;
    case '3Y':
      startDate.setFullYear(startDate.getFullYear() - 3);
      break;
    case '5Y':
      startDate.setFullYear(startDate.getFullYear() - 5);
      break;
    case 'MAX':
    default:
      // For MAX, use the first data point
      const firstItem = graphData[0];
      if (!firstItem) {
        return null;
      }
      const firstNav = firstItem.y;
      if (!firstNav || !lastNav || firstNav === 0) {
        return null;
      }
      const absoluteReturn = ((lastNav - firstNav) / firstNav) * 100;
      return absoluteReturn.toFixed(2);
  }

  // Find the data point closest to the start date
  const startTime = startDate.getTime();
  let closestItem = graphData[0];
  let closestDiff = Math.abs(new Date(graphData[0].x).getTime() - startTime);

  for (let i = 1; i < graphData.length; i++) {
    const itemTime = new Date(graphData[i].x).getTime();
    const diff = Math.abs(itemTime - startTime);
    if (diff < closestDiff) {
      closestDiff = diff;
      closestItem = graphData[i];
    }
    // If we've passed the start date, we can stop
    if (itemTime > startTime) {
      break;
    }
  }

  const firstNav = closestItem.y;
  if (!firstNav || !lastNav || firstNav === 0) {
    return null;
  }

  const absoluteReturn = ((lastNav - firstNav) / firstNav) * 100;
  return absoluteReturn.toFixed(2);
};

// Map time period to returns key
const getReturnsValue = (props: any, timePeriod: string) => {
  // Calculate absolute return from graph data for all time periods
  if (props.fundPerformaceData && props.fundPerformaceData.length > 0) {
    const absoluteReturn = calculateAbsoluteReturnForPeriod(
      props.fundPerformaceData,
      timePeriod
    );
    if (absoluteReturn !== null) {
      return absoluteReturn;
    }
  }

  // Fallback to CAGR returns from the returns object
  const returnsKeyMap: { [key: string]: string[] } = {
    '1M': ['return1mth', 'return1M'],
    '3M': ['return3mth', 'return3M'],
    '6M': ['return6mth', 'return6M'],
    '1Y': ['return1yr', 'return1Y'],
    '3Y': ['return3yr', 'return3Y'],
    '5Y': ['return5yr', 'return5Y'],
    MAX: ['returnSinceInception', 'returnALL'],
  };

  const keys = returnsKeyMap[timePeriod] || [];

  // Try to find the value using any of the possible keys
  if (props.returns) {
    for (const key of keys) {
      if (props.returns[key] !== undefined && props.returns[key] !== null) {
        return props.returns[key];
      }
    }
  }

  // Fallback to returnsSinceInception prop
  return props.returnsSinceInception;
};

const fundFinancialsBlock = (props: any) => {
  const selectedTimePeriod = props.selectedTimePeriod || '3Y';
  const returnsLabel = getReturnsLabel(selectedTimePeriod);
  const returnsValue = getReturnsValue(props, selectedTimePeriod);

  return (
    <div className="lil-flex lil-gap-8 sm:lil-flex-col sm:lil-gap-0 sm:lil-items-center lil-w-full">
      <div className="lil-flex-col">
        <div className="lil-text-grey-500 lil-text-s-18">
          NAV as of {formatEpochToDateString(props.navArr.dayEndDate)}
        </div>
        <div className="lil-flex lil-items-baseline">
          <p className="lil-text-black lil-text-s-32">
            ₹{props.navArr.dayEndNav.toFixed(2)}
          </p>
          <p className="lil-text-black lil-text-s-20 lil-font-light">
            <span
              className={`${
                props.navArr.navChangePercent < 0
                  ? 'lil-text-red'
                  : 'lil-text-green-450'
              } lil-px-2 lil-text-s-20`}
            >
              {props.navArr.navChangePercent}%
            </span>
            1D Change
          </p>
        </div>
      </div>

      <div className="lil-flex sm:lil-hidden">
        <div className="lil-border-l-sm lil-border-grey-300 lil-h-full" />
      </div>

      <div className="lil-flex-col">
        <div className="lil-text-grey-500 lil-text-s-18">{returnsLabel}</div>
        <p className="lil-text-black lil-text-s-20 lil-font-light">
          <span
            className={`${
              parseFloat(returnsValue) < 0
                ? 'lil-text-red'
                : 'lil-text-green-450'
            } lil-text-s-32 lil-font-medium`}
          >
            {parseFloat(returnsValue) >= 0 ? '+' : ''}
            {returnsValue}% {parseFloat(returnsValue) >= 0 ? '↑' : '↓'}
          </span>
        </p>
      </div>
    </div>
  );
};

const renderTitleSectionWeb = (props: any) => {
  return (
    <div className="lil-container lil-mx-auto lil-px-4">
      <div
        className={`lil-flex lil-pt-12 md:lil-pt-6 sm:lil-pt-4 sm:lil-w-full lil-flex-wrap ${
          !props.isNfo ? '' : ''
        }`}
      >
        {props.imgURL && (
          <div className="lil-w-1/12 sm:lil-w-1/6">
            <img
              className="lil-rounded-md sm:lil-hidden"
              src={`https://assets1.cleartax-cdn.com/clearsave${props.imgURL}`}
              width="80"
            />
            <img
              className="lil-rounded-md md:lil-hidden xl:lil-hidden lg:lil-hidden sm:lil-mt-1"
              src={`https://assets1.cleartax-cdn.com/clearsave${props.imgURL}`}
              width="40"
            />
          </div>
        )}
        <div
          className={`lil-flex lil-flex-wrap lil-w-5/12 lil-pr-4 sm:lil-pl-0 sm:lil-w-5/6 ${
            props.imgURL ? 'lil-pl-6' : 'lil-pl-0'
          }`}
        >
          <h1
            className={`lil-w-full lil-text-s-32 sm:lil-text-s-24 ${
              props.isNfo ? 'lil-pb-4' : 'lil-pb-4 sm:lil-pb-0'
            }`}
          >
            {props.name || props.title}
          </h1>
          <div className="sm:lil-hidden">{fundDetailsBlock(props)}</div>
        </div>
        {!props.isNfo ? (
          <div className="lil-w-6/12 sm:lil-hidden">
            {/* <PlanHighlightsNew data={returnHighlights(props.returnsLabelArr)} /> */}
            {fundFinancialsBlock(props)}
          </div>
        ) : null}
      </div>
      <div className="lil-flex">
        <div className="lil-flex-wrap lil-hidden lil-items-center lil-w-full sm:lil-flex sm:lil-justify-between">
          <div className={`${props.isNfo ? 'lil-pl-12' : ''}`}>
            {fundDetailsBlock(props)}
          </div>
          {!props.isNfo ? (
            <div className="md:lil-hidden xl:lil-hidden lg:lil-hidden">
              {/* <PlanHighlightsNew
                data={returnHighlights(props.returnsLabelArr)}
              /> */}
              {fundFinancialsBlock(props)}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const fundDetailsBlockMobile = (props: any) => {
  return (
    <div className="lil-flex lil-items-center lil-text-blue-300 lil-text-s-14 lil-mt-1">
      {props.risk && (
        <span className="lil-mr-1">{toTitleCase(props.risk)}Risk</span>
      )}

      {props.risk && props.category && <span className="lil-mx-1">|</span>}

      {props.category && (
        <span className="lil-mr-1">{toTitleCase(props.category)}</span>
      )}

      {props.category &&
        !props.isNfo &&
        props.morningStar &&
        Number(props.morningStar) > 0 && <span className="lil-mx-1">|</span>}

      {!props.isNfo && props.morningStar && Number(props.morningStar) > 0 ? (
        <span className="lil-mr-1">{props.morningStar} Star</span>
      ) : (
        ''
      )}

      {/* {props.isElss && props.ELSS && (
        <div className="lil-flex lil-items-center">
          <span className="lil-mx-1">|</span>
          <span className="lil-mr-1">{props.ELSS}</span>
        </div>
      )} */}
    </div>
  );
};

// const fundFinancialsBlockMobile = (props: any) => {
//   return (
//     <div className="lil-flex lil-justify-center lil-w-full lil-mt-6">
//       <div className="lil-w-3/5 lil-flex lil-flex-col lil-text-left">
//         <div className="lil-text-grey-500 lil-text-s-14">
//           NAV as of {formatEpochToDateString(props.navArr.dayEndDate)}
//         </div>
//         <div className="lil-flex lil-items-baseline lil-mt-1">
//           <p className="lil-text-black lil-text-s-24">
//             ₹{props.navArr.dayEndNav.toFixed(2)}
//           </p>
//           <p className="lil-text-black lil-text-s-14 lil-font-light">
//             <span
//               className={`${
//                 props.navArr.navChangePercent < 0
//                   ? 'lil-text-red'
//                   : 'lil-text-green-450'
//               } lil-px-2 lil-text-s-14`}
//             >
//               {props.navArr.navChangePercent}%
//             </span>
//             1D Change
//           </p>
//         </div>

//         <div className="lil-mt-2">
//           <div className="lil-text-grey-500 lil-text-s-14">
//             Returns since inception
//           </div>
//           <p className="lil-text-black lil-text-s-14 lil-font-light lil-flex lil-items-baseline">
//             <span
//               className={`${
//                 parseFloat(props.returnsSinceInception) < 0
//                   ? 'lil-text-red'
//                   : 'lil-text-green-450'
//               } lil-px-2 lil-text-s-24 lil-font-medium`}
//             >
//               {props.returnsSinceInception}%
//             </span>
//             p.a.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

const fundFinancialsBlockMobile = (props: any) => {
  const selectedTimePeriod = props.selectedTimePeriod || '3Y';
  const returnsLabel = getReturnsLabel(selectedTimePeriod);
  const returnsValue = getReturnsValue(props, selectedTimePeriod);

  return (
    <div className="lil-w-full lil-mt-6">
      <div className="lil-flex lil-justify-between">
        <div className="lil-w-1/2 lil-flex lil-justify-center">
          <div className="lil-text-left">
            <div className="lil-text-grey-500 lil-text-s-14">
              NAV as of {formatEpochToDateString(props.navArr.dayEndDate)}
            </div>

            <div className="lil-flex lil-items-baseline lil-mt-1">
              <p className="lil-text-black lil-text-s-24">
                ₹{props.navArr.dayEndNav.toFixed(2)}
              </p>
              <p className="lil-text-black lil-text-s-14 lil-font-light">
                <span
                  className={`${
                    props.navArr.navChangePercent < 0
                      ? 'lil-text-red'
                      : 'lil-text-green-450'
                  } lil-px-2 lil-text-s-14`}
                >
                  {props.navArr.navChangePercent}%
                </span>
                1D
              </p>
            </div>
          </div>
        </div>

        <div className="lil-w-1/2 lil-flex lil-justify-center">
          <div className="lil-text-left">
            <div className="lil-text-grey-500 lil-text-s-14">
              {returnsLabel}
            </div>
            <p className="lil-text-black lil-text-s-14 lil-font-light lil-flex lil-items-baseline lil-mt-1">
              <span
                className={`${
                  parseFloat(returnsValue) < 0
                    ? 'lil-text-red'
                    : 'lil-text-green-450'
                } lil-text-s-24 lil-font-medium`}
              >
                {parseFloat(returnsValue) >= 0 ? '+' : ''}
                {returnsValue}% {parseFloat(returnsValue) >= 0 ? '↑' : '↓'}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const renderTitleSectionMobile = (props: any) => {
  return (
    <div className="lil-container lil-mx-auto lil-px-4 lil-py-4">
      <div className="lil-flex lil-w-full">
        {props.imgURL && (
          <div className="lil-w-1/6 lil-mr-3">
            <img
              className="lil-rounded-md"
              src={`https://assets1.cleartax-cdn.com/clearsave${props.imgURL}`}
              width="50"
            />
          </div>
        )}

        <div className="lil-flex lil-flex-col lil-w-5/6">
          <h1 className="lil-text-s-24 lil-font-semibold">
            {props.name || props.title}
          </h1>
          {fundDetailsBlockMobile(props)}
        </div>
      </div>

      {/* Financials block stacked vertically */}
      <div className="lil-mt-2 lil-w-full">
        {!props.isNfo ? fundFinancialsBlockMobile(props) : null}
      </div>
    </div>
  );
};

const SingleFundTitleNew = (props: any) => {
  return (
    <div>
      <div className="sm:lil-hidden">{renderTitleSectionWeb(props)}</div>
      <div className="md:lil-hidden lg:lil-hidden xl:lil-hidden">
        {renderTitleSectionMobile(props)}
      </div>
    </div>
  );
};

export default SingleFundTitleNew;



// WEBPACK FOOTER //
// ./components/singleFund/singleFundTitleNew.tsx